<template>
  <div>
    <div style="margin-bottom: 5px">
      <el-input v-model="name" placeholder="请输入物品名" suffix-icon="el-icon-a-042" style="width: 180px"
        @keyup.enter.native="loadPost"></el-input>
      <el-input v-model="username" placeholder="请输入申请人" style="width: 180px;margin-left: 5px"
        @keyup.enter.native="loadPost"></el-input>
      <el-select v-model="storage" placeholder="请选择仓库" style="margin-left: 5px;width: 150px">
        <el-option v-for="item in storageData" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <el-select v-model="goodstype" placeholder="请选择分类" style="margin-left: 5px;width: 150px">
        <el-option v-for="item in goodstypeData" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <el-select v-model="actionType" placeholder="操作类型" style="margin-left: 5px;width:130px" clearable>
        <el-option label="全部" value=""></el-option>
        <el-option label="入库" value="1"></el-option>
        <el-option label="出库" value="2"></el-option>
      </el-select>
      <el-button type="primary" style="margin-left: 5px; font-size: 18px" @click="loadPost">
        查询
      </el-button>
      <el-button type="warning" style="font-size: 18px;margin-left: 5px" @click="resetParam">
        重置
      </el-button>
    </div>
    <el-table :data="tableData" :header-cell-style="{ background: '#f2f5fc', color: '#555555' }" border :stripe="true"
      :show-overflow-tooltip="true" show-summary :summary-method="getSummaries">
      <el-table-column type="index" label="ID" width="80" align="center"></el-table-column>
      <el-table-column prop="goodsname" label="物品名" width="150" align="center"></el-table-column>
      <el-table-column prop="storagename" label="仓库" width="150" align="center"></el-table-column>
      <el-table-column prop="goodstypename" label="分类" width="150" align="center"></el-table-column>
      <el-table-column prop="adminname" label="操作人" width="120" align="center"></el-table-column>
      <el-table-column label="申请人" width="120" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.username || '/' }}</span>
        </template>
      </el-table-column>
      <!-- 单价：双击编辑 -->
      <el-table-column prop="price" label="单价" width="120" align="center">
        <template slot-scope="scope">
          <div @dblclick="startEditPrice(scope)" style="cursor: pointer; padding: 2px;">
            <span v-if="editingRowId !== scope.row.id">
              {{ scope.row.price ? scope.row.price + ' 元' : '-' }}
            </span>
            <el-input v-else v-model="tempPrice" size="mini" @blur="savePrice(scope.row)"
              @keydown.enter.native="savePrice(scope.row)" ref="priceInput" style="width: 100px;" />
          </div>
        </template>
      </el-table-column>

      <el-table-column label="数量" width="120" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.count > 0" style="color: #008000; font-weight:bold">
            +{{ scope.row.count }}
          </span>
          <span v-else style="color: #F56C6C; font-weight:bold">
            {{ scope.row.count }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="createtime" label="操作时间" width="180" align="center"></el-table-column>
      <el-table-column prop="remark" label="备注"></el-table-column>
      <el-table-column label="操作" width="90" align="center">
        <template slot-scope="scope">
          <el-button v-if="user.roleId !== 1" type="text" icon="el-icon-delete"
            @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
      :page-sizes="[5, 10, 20, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "RecordManage",
  data() {
    return {
      user: JSON.parse(sessionStorage.getItem("CurUser")),
      storageData: [],
      goodstypeData: [],
      tableData: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      name: "",
      username: "",
      storage: "",
      goodstype: "",
      actionType: "",

      // 双击编辑单价用
      editingRowId: null,
      tempPrice: ""
    };
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      let inCount = 0;
      let inAmount = 0;
      let outCount = 0;

      data.forEach(row => {
        const cnt = Number(row.count || 0);
        const price = Number(row.price || 0);
        const rowTotal = cnt * price;
        if (cnt > 0) {
          inCount += cnt;
          inAmount += rowTotal;
        } else {
          outCount += Math.abs(cnt);
        }
      });

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "本页合计";
          return;
        }
        if (index === 6) {
          sums[index] = `入:${inAmount.toFixed(2)}元`;
        } else if (index === 7) {
          //把 | 换成 /，更清爽
          sums[index] = `入:${inCount} / 出:${outCount}`;
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    handleDelete(row) {
      this.$confirm("确定删除这条操作日志？\n⚠️警告：只删除日志，库存**不会自动回滚**，库存需要手动调整！", "删除确认", {
        confirmButtonText: "确定删除",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$axios.get(this.$httpUrl + "/record/del?id=" + row.id).then(res => {
          if (res.data.code === 200) {
            this.$message.success("删除成功");
            this.loadPost();
          } else {
            this.$message.error("删除失败");
          }
        })
      }).catch(() => {
        //点击取消不做处理
      })
    },
    // 双击进入编辑
    startEditPrice(scope) {
      // 只有入库记录才允许改单价（count>0）
      if (scope.row.count <= 0) {
        this.$message.warning("只能修改入库记录的单价");
        return;
      }
      this.editingRowId = scope.row.id;
      this.tempPrice = scope.row.price || "";
      this.$nextTick(() => {
        this.$refs.priceInput && this.$refs.priceInput.focus();
      });
    },

    // 保存单价到后端
    savePrice(row) {
      let val = parseFloat(this.tempPrice);
      if (isNaN(val) || val <= 0) {
        this.$message.warning("请输入合法单价");
        this.editingRowId = null;
        return;
      }

      this.$axios.post(this.$httpUrl + "/record/updatePrice", {
        id: row.id,
        goodsId: row.goods,
        oldPrice: row.price,
        newPrice: val,
        count: Math.abs(row.count)
      }).then(res => {
        if (res.data.code === 200) {
          this.$message.success("单价修改成功，总金额已自动同步");
        } else {
          this.$message.error("修改失败");
        }
      }).finally(() => {
        this.editingRowId = null;
        this.loadPost();
      });
    },
    formatStorage(row) {
      let temp = this.storageData.find((item) => {
        return item.id == row.storage;
      });
      return temp && temp.name;
    },
    formatGoodstype(row) {
      let temp = this.goodstypeData.find((item) => {
        return item.id == row.goodstype;
      });
      return temp && temp.name;
    },
    handleSizeChange(val) {
      this.pageNum = 1;
      this.pageSize = val;
      this.loadPost();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadPost();
    },
    resetParam() {
      this.name = "";
      this.username = "";
      this.storage = "";
      this.goodstype = "";
      this.actionType = "";
      this.loadPost();
    },
    loadStorage() {
      this.$axios.get(this.$httpUrl + "/storage/list")
        .then(res => res.data)
        .then(res => {
          if (res.code === 200) this.storageData = res.data;
        });
    },
    loadGoodstype() {
      this.$axios.get(this.$httpUrl + "/goodstype/list")
        .then(res => res.data)
        .then(res => {
          if (res.code === 200) this.goodstypeData = res.data;
        });
    },
    loadPost() {
      this.$axios.post(this.$httpUrl + "/record/listPage", {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        param: {
          name: this.name,
          username: this.username,
          goodstype: this.goodstype + "",
          storage: this.storage + "",
          roleId: this.user.roleId + "",
          userId: this.user.id + "",
          actionType: this.actionType + ""
          // deleted:0 删除，后端已经写死 a.deleted=0
        },
      }).then(res => res.data).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.total = res.total;
        }
      });
    },
  },
  beforeMount() {
    this.loadStorage();
    this.loadGoodstype();
    this.loadPost();
  },
};
</script>

<style scoped></style>